<mat-form-field class="disabled-looking">
  <input matInput [value]="value" [disabled]="true" />
  <mat-label>{{ label }}</mat-label>
</mat-form-field>
